import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

export const VkClipsAndStories: React.FC = () => {
  return <div id={"VkClipsAndStories"}>
    <h2>
      VK Клипы и Истории: как добавить трек в
      каталоги
    </h2>
    <p className={"font-bold"}>
      Прослушивание трека внутри истории или клипа — это нефинансовое событие, которое не отобразится в отчётности. По
      этой причине добавить разрешения на VK Клипы и Истории можно только в контент с полными долями (100%) авторских
      прав.
    </p>
    <p>
      Чтобы включить разрешения, отметьте галочками пункты «Добавить в Истории» и «Добавить в VK Клипы» при настройке
      сервиса «Стриминг» на треках в альбоме. Не забудьте сохранить изменения и опубликовать Черновик.
    </p>
    <div className={"text-center"}>
      <img className={"max-h-[350px]"} src={"/help/add_to_vk.jpg"} alt={"Добавить новый альбом"} />
    </div>
  </div>;
};
